import { render, staticRenderFns } from "./support.vue?vue&type=template&id=5904a9a5"
import script from "./support.vue?vue&type=script&lang=js"
export * from "./support.vue?vue&type=script&lang=js"
import style0 from "./support.vue?vue&type=style&index=0&id=5904a9a5&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5904a9a5')) {
      api.createRecord('5904a9a5', component.options)
    } else {
      api.reload('5904a9a5', component.options)
    }
    module.hot.accept("./support.vue?vue&type=template&id=5904a9a5", function () {
      api.rerender('5904a9a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/support/support.vue"
export default component.exports